import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { X } from "lucide-react";

const WhatsAppBubble = () => {
  const location = useLocation();
  const [showMessage, setShowMessage] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [bubbleMessage, setBubbleMessage] = useState("");
  const [loaded, setLoaded] = useState(false);

  // Hide on admin/partner routes
  const hidden = location.pathname.startsWith("/admin") || location.pathname.startsWith("/partener");

  useEffect(() => {
    const fetchSettings = async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("key, value")
        .in("key", ["contact_whatsapp", "whatsapp_bubble_message"]);
      if (data) {
        data.forEach((row) => {
          if (row.key === "contact_whatsapp") setWhatsappNumber(row.value);
          if (row.key === "whatsapp_bubble_message") setBubbleMessage(row.value);
        });
      }
      setLoaded(true);
    };
    if (!hidden) fetchSettings();
  }, [hidden]);

  useEffect(() => {
    if (!loaded || hidden || !whatsappNumber) return;
    const timer = setTimeout(() => setShowMessage(true), 10000);
    return () => clearTimeout(timer);
  }, [loaded, hidden, whatsappNumber]);

  if (hidden || !loaded || !whatsappNumber) return null;

  const waUrl = `https://wa.me/${whatsappNumber}`;

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
      {/* Tooltip message */}
      {showMessage && !dismissed && bubbleMessage && (
        <div className="animate-in fade-in-0 slide-in-from-bottom-2 duration-300 relative max-w-[250px] rounded-xl bg-white p-4 pr-8 text-sm text-gray-800 shadow-lg border border-gray-100">
          <button
            onClick={(e) => { e.stopPropagation(); setDismissed(true); }}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Închide"
          >
            <X size={14} />
          </button>
          <p>{bubbleMessage}</p>
        </div>
      )}

      {/* WhatsApp bubble */}
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="animate-in fade-in-0 zoom-in-75 duration-500 flex h-14 w-14 md:h-[56px] md:w-[56px] items-center justify-center rounded-full shadow-lg hover:shadow-xl transition-shadow"
        style={{ backgroundColor: "#25D366" }}
        aria-label="WhatsApp"
      >
        <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white">
          <path d="M16.004 3.2C9.054 3.2 3.404 8.85 3.404 15.8c0 2.22.58 4.39 1.68 6.3L3.2 28.8l6.93-1.82a12.56 12.56 0 006.874 1.62h-.004c6.95 0 12.6-5.65 12.6-12.6 0-3.37-1.31-6.53-3.69-8.91A12.52 12.52 0 0016.004 3.2zm0 23.05a10.43 10.43 0 01-5.32-1.46l-.38-.23-3.96 1.04 1.06-3.87-.25-.4a10.4 10.4 0 01-1.6-5.48c0-5.78 4.7-10.48 10.49-10.48 2.8 0 5.43 1.09 7.41 3.07a10.42 10.42 0 013.07 7.41c0 5.78-4.7 10.48-10.48 10.48v-.08zm5.75-7.85c-.32-.16-1.87-.92-2.16-1.03-.29-.1-.5-.16-.71.16-.21.32-.82 1.03-1 1.24-.19.21-.38.24-.7.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.89-1.78-2.21-.19-.32-.02-.5.14-.66.15-.15.32-.38.48-.57.16-.19.21-.32.32-.54.1-.21.05-.4-.03-.57-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.54-.71-.55h-.61c-.21 0-.54.08-.83.4-.29.32-1.09 1.06-1.09 2.6 0 1.53 1.11 3.01 1.27 3.22.16.21 2.19 3.35 5.3 4.7.74.32 1.32.51 1.77.66.74.24 1.42.2 1.95.12.6-.09 1.87-.77 2.13-1.51.27-.74.27-1.38.19-1.51-.08-.14-.29-.22-.61-.38z" />
        </svg>
      </a>
    </div>
  );
};

export default WhatsAppBubble;
